import { useParams, useHistory } from "react-router-dom";
import EWallet from "./";
import { useSelector, useDispatch } from "react-redux";
import { useEffect, useMemo, useState } from "react";
import { userList } from "../../../redux/actions/dbactions/profileActions";
import { Spinner } from "react-bootstrap";
import { Header } from "../../Header";
import { Icon } from "@iconify/react/dist/iconify.js";

export const UserWalletDetails = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { userId } = useParams();
  const { user, isLoading } = useSelector((state) => state.user || {});
  const [selectedUser, setSelectedUser] = useState({});

  const allUsers = useMemo(() => user?.usr?.data || [], [user.usr?.data]);

  useEffect(() => {
    if (allUsers.length > 0) {
      const data = allUsers.find((usr) => usr.user_profile_id === +userId);
      setSelectedUser(data || allUsers[0]);
    }
  }, [allUsers, userId]);

  const handleUserChange = (e) => {
    const { value } = e.target;
    history.push(`/dashboard/users/wallet/${value}`);
  };

  useEffect(() => {
    dispatch(userList());
  }, [dispatch]);

  if (isLoading && allUsers?.length === 0)
    return (
      <div className="text-center">
        <Spinner animation="border" variant="primary" />
      </div>
    );

  return (
    <>
      <Header
        pageTitle="Wallet"
        icon={
          <Icon icon="material-symbols-light:account-balance-wallet-outline" />
        }
      />
      <div className="p-6 pb-0 w-full">
        <label className="block !text-lg font-medium mb-0">Select User:</label>
        <select
          className="p-2 px-3 border rounded-lg w-full text-lg bg-gray-100"
          value={selectedUser?.user_profile_id || ""}
          onChange={handleUserChange}
        >
          {allUsers.map((user) => (
            <option key={user.user_profile_id} value={user.user_profile_id}>
              {user.user_first_name}
            </option>
          ))}
        </select>
      </div>
      <EWallet isAdmin={true} />
    </>
  );
};
